<div class="spinner-section" *ngIf="showSpinner">
      <!-- Show spinner when loading -->
      <mat-progress-spinner
        class="custom-spinner-color"
        [mode]="mode"
        [value]="value"
        [diameter]="20" 
        [strokeWidth]="2" 
      ></mat-progress-spinner>
</div>